
import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import Loader from '../../loader/Loader';
import Footer from '../Footer/Footer';
import Terms from './Terms';
import { useLocale } from '../../localization/LocaleContext';

function TermsMain() {
    const { t } = useLocale();
    useEffect(() => {
        document.title = t('meta.termsTitle')
   }, [t]);
   const[loader, SetLoader] = useState(false)
    useEffect(() => {
        const timer = setTimeout(() => {
            SetLoader(true)
        },1500)

        return () => clearTimeout(timer)
    }, [])
    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
            <Terms/>
            <Footer/>
        </Fragment>
    )
    
}

export default TermsMain;